/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RubricEnabledForTeacherOnSubmissionsPageSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('RUBRIC_ENABLED_FOR_TEACHER_ON_SUBMISSIONS_PAGE'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class RubricEnabledForTeacherOnSubmissionsPageSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RubricEnabledForTeacherOnSubmissionsPageSettingParser.decode(input).map(res => new RubricEnabledForTeacherOnSubmissionsPageSetting(res));
    }
    static unsafeDecode(input) {
        return RubricEnabledForTeacherOnSubmissionsPageSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricEnabledForTeacherOnSubmissionsPageSettingParser.encode(data);
    }
    static schema() {
        return RubricEnabledForTeacherOnSubmissionsPageSettingParser.schema();
    }
}
